import {
    ScheduleSubModes,
    isAccruedScheduleMode,
} from "@common/helpers/domains/accounting/accruedScheduleMode";
import { accountingCurrencyFormatter } from "@common/helpers/currency";
import { ScheduleSourceType } from "@common/types/domains/accounting/schedule";

export function isAccruedBilledSource(options: {
    subModes: Partial<ScheduleSubModes> | undefined;
    sourceType: ScheduleSourceType;
}): boolean {
    const { subModes, sourceType } = options;
    if (!subModes) {
        return false;
    }
    return (
        isAccruedScheduleMode(subModes) &&
        sourceType !== ScheduleSourceType.manual
    );
}

interface AccruedTermPeriod {
    periodLabel: string;
    recognized: number;
}

export function summarizeAccruedTerm(
    periods: AccruedTermPeriod[],
): string | null {
    const first = periods[0];
    const last = periods[periods.length - 1];
    if (!first || !last) {
        return null;
    }
    const amounts = periods.map((period) => period.recognized);
    const smallest = Math.min(...amounts);
    const largest = Math.max(...amounts);
    const span =
        periods.length === 1
            ? first.periodLabel
            : `${first.periodLabel} – ${last.periodLabel}`;
    const format = (amount: number) =>
        accountingCurrencyFormatter.format(amount);
    return smallest === largest
        ? `${periods.length} × ${format(smallest)}, ${span}`
        : `${periods.length} periods of ${format(smallest)} to ${format(largest)}, ${span}`;
}
